var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-logic-container" }, [
    _c(
      "div",
      { staticClass: "show-logic-container" },
      _vm._l(_vm.logicList, function (logicItem, index) {
        return _c(
          "div",
          { key: logicItem.id, staticClass: "logic-item" },
          [
            _c(
              "div",
              {
                staticClass: "logic-item-delete",
                on: {
                  click: function ($event) {
                    return _vm.handleRemoveLogicItem(index)
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-delete" })]
            ),
            _vm._l(logicItem.conditions, function (cItem, cIndex) {
              return _c(
                "el-row",
                {
                  key: cIndex,
                  staticClass: "mt5",
                  attrs: {
                    gutter: 20,
                    align: "middle",
                    justify: "center",
                    type: "flex",
                  },
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "text-center", attrs: { span: 3 } },
                    [
                      cIndex === 0
                        ? _c("span", [_vm._v("如果：")])
                        : _c(
                            "el-select",
                            {
                              attrs: { disabled: cIndex !== 1 },
                              on: {
                                change: function (val) {
                                  return _vm.relationChangeHandle(
                                    val,
                                    logicItem
                                  )
                                },
                              },
                              model: {
                                value: logicItem.relation,
                                callback: function ($$v) {
                                  _vm.$set(logicItem, "relation", $$v)
                                },
                                expression: "logicItem.relation",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "并且", value: "AND" },
                              }),
                              _c("el-option", {
                                attrs: { label: "或者", value: "OR" },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-select",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleClearExpression(cItem)
                            },
                          },
                          model: {
                            value: cItem.type,
                            callback: function ($$v) {
                              _vm.$set(cItem, "type", $$v)
                            },
                            expression: "cItem.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "题目", value: "_TITLE" },
                          }),
                          _c("el-option", {
                            attrs: { label: "外部参数", value: "_PARAMETERS" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      cItem.type === "_PARAMETERS"
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "80%" },
                              attrs: { placeholder: "请选择参数" },
                              model: {
                                value: cItem.parameter,
                                callback: function ($$v) {
                                  _vm.$set(cItem, "parameter", $$v)
                                },
                                expression: "cItem.parameter",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "菜品编码", value: "product" },
                              }),
                            ],
                            1
                          )
                        : _c("el-cascader", {
                            attrs: {
                              options:
                                _vm.getConditionProjectItemList(logicItem),
                              filterable: true,
                              "show-all-levels": false,
                              placeholder: "请选择题目",
                              props: {
                                expandTrigger: "hover",
                                emitPath: false,
                              },
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleConditionChange(cItem)
                              },
                            },
                            model: {
                              value: cItem.formItemId,
                              callback: function ($$v) {
                                _vm.$set(cItem, "formItemId", $$v)
                              },
                              expression: "cItem.formItemId",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择条件" },
                          model: {
                            value: cItem.expression,
                            callback: function ($$v) {
                              _vm.$set(cItem, "expression", $$v)
                            },
                            expression: "cItem.expression",
                          },
                        },
                        _vm._l(_vm.getConditionOptions(cItem), function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      ["NPS", "RATE"].includes(
                        _vm.getFormItemIdType(cItem.formItemId)
                      )
                        ? _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: cItem.optionValue,
                              callback: function ($$v) {
                                _vm.$set(cItem, "optionValue", $$v)
                              },
                              expression: "cItem.optionValue",
                            },
                          })
                        : _vm.checkoIsInput(cItem.formItemId) ||
                          cItem.type == "_PARAMETERS"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.openkeywordDialogHandle(cItem)
                                },
                              },
                            },
                            [_vm._v(" 设置关键词 ")]
                          )
                        : _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择选项" },
                              model: {
                                value: cItem.optionValue,
                                callback: function ($$v) {
                                  _vm.$set(cItem, "optionValue", $$v)
                                },
                                expression: "cItem.optionValue",
                              },
                            },
                            _vm._l(
                              _vm.getFormItemOptions(cItem.formItemId),
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.addConditionHandle(logicItem, cItem)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-circle-plus-outline",
                          }),
                        ]
                      ),
                      cIndex !== 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "remove",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeConditionHandle(
                                    logicItem,
                                    index,
                                    cIndex
                                  )
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-remove-outline" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            _c("el-divider"),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置关键词",
                  visible: _vm.dialogVisible,
                  width: "30%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogVisible = $event
                  },
                },
              },
              [
                _c("span", { staticClass: "desc-text" }, [
                  _vm._v("每行一个关键词，不需要标点符号"),
                ]),
                _c("el-input", {
                  staticClass: "mt-10",
                  attrs: {
                    type: "textarea",
                    autosize: { minRows: 10, maxRows: 5000 },
                    placeholder: "关键词1",
                  },
                  model: {
                    value: _vm.batchItemValue,
                    callback: function ($$v) {
                      _vm.batchItemValue = $$v
                    },
                    expression: "batchItemValue",
                  },
                }),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.keywordEditSelectItems },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }